<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="500">
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
          rounded
          height="6"
        ></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ titleMode }} estado
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 370px">
            <v-form>
              <v-row dense>
                <!-- Nombre -->
                <v-col cols="12">
                  <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Nombre"
                      name="name"
                      type="text"
                      color="blue-grey"
                      v-model="formData.name"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Marcar -->
                <v-col cols="12" class="px-3">
                  <ValidationProvider name="marcar" rules="required" v-slot="{ errors }">
                    <v-radio-group
                      v-model="formData.call_on"
                      :error-messages="errors"
                      row
                    >
                      <template v-slot:label>
                        Status
                      </template>
                      <v-radio label="Sí" :value="1"></v-radio>
                      <v-radio label="No" :value="0"></v-radio>
                    </v-radio-group>
                  </ValidationProvider>
                </v-col>

                <!-- Prioridad -->
                <v-col cols="12" class="px-3">
                  <v-checkbox
                    v-model="formData.priority"
                    label="Prioridad"
                    color="primary"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog(null)"
              >Cancelar</v-btn
            >
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click.stop="handleSubmit(submitForm)"
              >{{ submitButtonMode }}</v-btn
            >
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import axios from "axios";
import vuescroll from "vuescroll";

export default {
  components: { vuescroll },
  props: {
    dialog: {
      type: Boolean,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    axios: {
      type: Function,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      titleMode: this.editMode ? "Actualizar" : "Crear",
      submitButtonMode: this.editMode ? "Guardar" : "Crear",
      formData: this.editMode
        ? this.data
        : {
            name: "",
            call_on: null,
            priority: null,
          },
    };
  },

  created() {
    this.axiosInstance = axios.create({
      baseURL: process.env.VUE_APP_ROOTAPI,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
  },

  methods: {
    closeDialog(item) {
      this.$emit("dialog:close", item);
    },

    async submitForm() {
      let data;
      this.isLoading = true;
      try {
        if (this.editMode) {
          const { id, ...payload } = this.formData;
          const res = await this.axios.put(
            `campaign/register_status/${this.data.id}`,
            payload
          );
          data = res.data;
          this.$snotify.success("Actualizado con exito", "¡Hecho!");
        } else {
          const res = await this.axios.post("/campaign/register_status", this.formData);
          data = res.data;
          this.$snotify.success("Creado con exito", "¡Hecho!");
        }
        this.closeDialog(data.status_register);
      } catch (err) {
        this.$snotify.error("Hubo un error guardando la campaña", "¡Error!");
        // console.log("Error in post:", err);
      }
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
